import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'roleFilter' })

export class RoleFilterPipe implements PipeTransform {
    transform(data?: string | null) {
        if (data === null || data === '') return '';
        if (!(typeof String(data))) return data;

        var roleName = '';

        switch (data) {
            case 'Developer': roleName = 'Developer Access'; break;
            case 'SystemAdmin': roleName = 'System Administrator Access'; break;
            case 'Clearinghouse': roleName = 'Clearinghouse Team Access'; break;
            case 'ProgramContact': roleName = 'Program Contact Access'; break;
            case 'DistrictStaff': roleName = 'District Staff Access'; break;
            case 'Principal': roleName = 'School Principal Access'; break;
            case 'AssistantPrin': roleName = 'School Assistant Principal Access'; break;
            case 'Counselor': roleName = 'School Counselor Access'; break;
            case 'SuccessCoach': roleName = 'Success Coach Access'; break;
            case 'StudentAdvisor': roleName = 'Student Advisor Access'; break;
            case 'Designee': roleName = 'Designee Access'; break;
            case 'Reader': roleName = 'Application Reader Access'; break;
        }

        if (data === '') return data;

        return roleName;
    }
}